/* eslint-disable react/style-prop-object */
/* eslint-disable react/no-unknown-property */
/* eslint-disable react/button-has-type */
/* eslint-disable react/no-array-index-key */
/* eslint-disable no-undef */
/* eslint-disable react/function-component-definition */
/* eslint-disable prettier/prettier */
/* eslint-disable react/self-closing-comp */
import React from 'react';
import ResearchImage from '../assets/research.png';
import DesignImage from '../assets/design.png';
import Fade from 'react-reveal/Fade';
import Zoom from 'react-reveal/Zoom';
import Bounce from 'react-reveal/Bounce';
import Slide from 'react-reveal/Slide';
import BuildImage from '../assets/build.png';

const cards = [
  {
    imageSrc: ResearchImage,
    name: '1 Research',
    description:
      'We work with you to understand user’s stories and validate your idea with real users using lean design sprints.',
  },
  {
    imageSrc: DesignImage,
    name: '2 Design',
    description:
      'Expanding on the insights gained, you’ll work closely with our design team to create an elegant design',
  },
  {
    imageSrc: BuildImage,
    name: '3 Build',
    description:
      'With our scrum-based agile methodology, you’ll receive iterative builds every weeks',
  },
];

const backendSkills = [
  { name: 'Node.js' },
  { name: 'Express.js' },
  { name: 'MongoDB' },
  { name: 'JavaScript | TypeScript' },
];
const websiteSkills = [
  { name: 'React.js' },
  { name: 'Next.js' },
  { name: 'Tailwind CSS' },
  { name: 'Material UI' },
  { name: 'Animations' },
  { name: 'JavaScript | TypeScript' },
];
const mobileApp = [
  { name: 'React Native' },
  { name: 'Redux | Redux ToolKit | Zustand' },
  { name: 'API Integrations(REST & GraphQL)' },
  { name: 'Google Maps' },
  { name: 'Payment Integrations' },
  { name: 'Push Notifications' },
  { name: 'Real Time Chats & Video/Audio Calling' },
  {
    name: 'AI-powered Features (Chatbots, Image Recognition, Text to Speach )',
  },
  { name: 'JavaScript | TypeScript' },
];
const Springsdesign = () => {
  return (
    <div className="spring-main">
      <div className="spring-inner">
        <div className="spring-h-cards">
          <div className="spring-heading-text">
            <Fade top>
              <h2>From Lean Design Sprints to Agile Development</h2>
              <p>
                Our process is designed to give you the best shot at success.
              </p>
            </Fade>
          </div>
          <div className="cards-main">
            {cards.map((card, index) => (
              <Bounce key={index}>
                <div className="research">
                  <img src={card.imageSrc} alt="" />
                  <h3>{card.name}</h3>
                  <p>{card.description}</p>
                </div>
              </Bounce>
            ))}
          </div>

          {/* Learning section */}
          <div className="learning-main">
            <div className="learning-text">
              <Slide left>
                <h2>Which is why we Never Stop Learning.</h2>
                <p className="learn-p1">
                  We believe that we succeed when our friends succeed.
                </p>
                <p className="learn-p2">
                  I’m Muhammad Aman, a Full Stack Developer specializing in
                  high-performance
                  <strong> website designs</strong>,{' '}
                  <strong>cross-platform mobile apps</strong>, and
                  <strong> scalable backend solutions</strong>. With years of
                  experience, I have built a diverse portfolio of responsive,
                  scalable websites and optimized Android & iOS applications
                  using cutting-edge technologies.
                </p>

                <p className="learn-p2 ">
                  I'm open to new opportunities, please feel free to connect if
                  you'd like to collaborate or discuss any opportunity.
                </p>
              </Slide>

              <Zoom>
                <div className="l-btn-text">
                  <p>Let's Discuss Your Project</p>
                  <ul>
                    <li>
                      <button
                        onClick={() => {
                          window.open(
                            "https://mail.google.com/mail/?view=cm&fs=1&to=muhammadamann72@gmail.com&body=Hi%20Muhammad%2C%0A%0AI%20came%20across%20your%20website%20and%20am%20interested%20in%20working%20with%20you.%20Here's%20a%20brief%20overview%20of%20my%20project%3A%0A%0A-%20[Project%20Details]%0A-%20[Requirements]%0A-%20[Timeline]%0A%0ALooking%20forward%20to%20your%20thoughts!%0A%0ABest%2C%0A[Your%20Name]",
                            '_blank',
                            'width=600,height=400'
                          );
                        }}
                        style={{
                          textDecoration: 'none',
                          color: 'inherit',
                          background: 'none',
                          border: 'none',
                          cursor: 'pointer',
                          fontSize: 16,
                        }}
                      >
                        Send Email
                      </button>
                    </li>
                  </ul>
                </div>
              </Zoom>
            </div>

            <div className="learning-skills">
              <Fade right>
                <div className="l-skills-1">
                  <h2>Web Development</h2>
                  {websiteSkills.map((website, index) => (
                    <div key={index} className="design-main">
                      <i
                        fill="currentColor"
                        style={{ display: 'inline-block' }}
                      >
                        <svg
                          fill="none"
                          style={{
                            display: 'inline-block',
                            verticalAlign: 'middle',
                          }}
                          height="12"
                          width="12"
                          viewBox="0 0 24 24"
                          stroke="currentColor"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        >
                          <line x1="12" y1="5" x2="12" y2="19"></line>
                          <line x1="5" y1="12" x2="19" y2="12"></line>
                        </svg>
                      </i>
                      <p>{website.name}</p>
                    </div>
                  ))}
                </div>
              </Fade>

              <Slide right>
                <div className="l-skills-1">
                  <h2>Mobile App Development</h2>
                  {mobileApp.map((app, index) => (
                    <div key={index} className="design-main">
                      <i
                        fill="currentColor"
                        style={{ display: 'inline-block' }}
                      >
                        <svg
                          fill="none"
                          style={{
                            display: 'inline-block',
                            verticalAlign: 'middle',
                          }}
                          height="12"
                          width="12"
                          viewBox="0 0 24 24"
                          stroke="currentColor"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        >
                          <line x1="12" y1="5" x2="12" y2="19"></line>
                          <line x1="5" y1="12" x2="19" y2="12"></line>
                        </svg>
                      </i>
                      <p>{app.name}</p>
                    </div>
                  ))}
                </div>
              </Slide>

              <Bounce>
                <div className="l-skills-1">
                  <h2>Back End</h2>
                  {backendSkills.map((design, index) => (
                    <div key={index} className="design-main">
                      <i
                        fill="currentColor"
                        style={{ display: 'inline-block' }}
                      >
                        <svg
                          fill="none"
                          style={{
                            display: 'inline-block',
                            verticalAlign: 'middle',
                          }}
                          height="12"
                          width="12"
                          viewBox="0 0 24 24"
                          stroke="currentColor"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        >
                          <line x1="12" y1="5" x2="12" y2="19"></line>
                          <line x1="5" y1="12" x2="19" y2="12"></line>
                        </svg>
                      </i>
                      <p>{design.name}</p>
                    </div>
                  ))}
                </div>
              </Bounce>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Springsdesign;
